

















import FadingScroll from '../../fading-scroll.component.vue';
import TransitionHeight from '../../transition-height.component.vue';
import KeywordDetails from './keyword-details.component.vue';

export default {
  name: 'epb-keywords-aside',
  props: {
    keywords: {
      type: Array, // KeywordData[]
      required: true
    },
    messages: {
      type: Object, // KeywordsMessages["aside"]
      required: true
    }
  },
  components: {
    FadingScroll,
    TransitionHeight,
    KeywordDetails
  },
  data: function () {
    return {
      baseClass: 'epb-keywords-aside'
    };
  }
};

